import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "CategoryTypeEditDialog",
  data: () => ({}),
  props: ["editedItem", "showCatTypeDialog"],
  methods: {
    async saveCatType() {
      const headers = await getTokenHeader();
      if (!this.editedItem._id) await this.createCatType(headers);
      else await this.updateCatType(headers);
      await this.$store.dispatch("getCategoryTypes", true);
      this.dialog = false;
    },
    async createCatType(headers) {
      const res = await axios.post(
        `${env.poi_api_client_url}categoryType`,
        this.editedItem,
        { headers }
      );
      if (res.status !== 201)
        await this.$store.dispatch(
          "createError",
          "Fehler beim Anlegen des Kategorie Typen"
        );
      else await this.$store.dispatch("createSuccess", "Erfolgreich erstellt");
    },
    async updateCatType(headers) {
      const res = await axios.put(
        `${env.poi_api_client_url}categoryType/${this.editedItem._id}`,
        this.editedItem,
        { headers }
      );
      if (res.status !== 200)
        await this.$store.dispatch(
          "createError",
          "Fehler beim Aktualisieren des Kategorie Typen"
        );
      else
        await this.$store.dispatch("createSuccess", "Erfolgreich aktualisiert");
    }
  },
  computed: {
    dialog: {
      get() {
        return this.showCatTypeDialog;
      },
      set(value) {
        if (!value) this.$emit("toggleCatTypeDialog", value);
      }
    }
  }
};
